
import { defineComponent, inject } from 'vue';
import { IMsg } from '_c/typings/model/im';
import { ImageSize } from '_c/typings/model/chat';
import { StickerMsg } from '_c/typings/proto';
import KkImage from '@/component/kk-image/kk-image.vue';
type StickerMessageViewData = {
  message: IMsg;
};

const MAX_IMAGE_WIDTH = 140;
const MAX_IMAGE_HEIGHT = 140;
const MIN_IMAGE_WIDTH = 140 / 3;
const MIN_IMAGE_HEIGHT = 140 / 3;
export default defineComponent({
  name: 'StickerMessageView',
  components: {
    KkImage,
  },
  data(): StickerMessageViewData {
    return {
      message: inject('messageData') as IMsg,
    };
  },
  computed: {
    stickerMsg(): StickerMsg|null {
      return this.message.stickerMsg || null;
    },
    size(): ImageSize {
      if (this.stickerMsg === null) {
        return {
          width: MIN_IMAGE_WIDTH,
          height: MIN_IMAGE_HEIGHT,
        };
      }
      const width = this.stickerMsg?.width ?? 0 / 2 * 0.8;
      const height = this.stickerMsg?.height ?? 0 / 2 * 0.8;
      if (width > MIN_IMAGE_WIDTH && width < MAX_IMAGE_WIDTH
        && height > MIN_IMAGE_HEIGHT && height < MAX_IMAGE_HEIGHT) {
        return {
          width,
          height,
        };
      }
      if (height >= width && height > MAX_IMAGE_HEIGHT) {
        const rate = width / height;
        return {
          width: MAX_IMAGE_HEIGHT * rate,
          height: MAX_IMAGE_HEIGHT,
        };
      }
      if (height <= width && width > MAX_IMAGE_WIDTH) {
        const rate = height / width;
        return {
          width: MAX_IMAGE_WIDTH,
          height: MAX_IMAGE_WIDTH * rate,
        };
      }
      return {
        width,
        height,
      };
    },
    style(): string {
      return `width:${this.size.width}px; height:${this.size.height}px;`;
    },
  },
});
